import * as $ from "jquery";

export default class LinkButtonLocalUtmsCapture{
  $domRoot: JQuery<HTMLElement>;
  params: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = { ...params };

    this.init();
  }

  getFormattedUtmKey(key: string) {
    switch(key) {
        case 'sfdcCampaignId':
            return 'utm_sfdc-campaign_id';
        case 'source':
            return 'utm_source';
        case 'medium':
            return 'utm_medium';
        case 'campaign':
            return 'utm_campaign';
        case 'content':
            return 'utm_content';
        default:
            return ""; // avoid forwarding non utms to href
    }
  }

  init () {
    const marketingContext = window.localStorage.getItem('marketingContext');
    let utmParams = "";

    let urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach((value, key) => {
        if (key.startsWith('utm_')) {
            utmParams += `${key}=${value}&`;
        }
    });

    if (utmParams === "" && marketingContext) {
        try {
            const parsedMarketingContext = JSON.parse(marketingContext);
            const utms = parsedMarketingContext.utm;
            if (utms) {
                for (const [key, value] of Object.entries(utms)) {
                    const formattedKey = this.getFormattedUtmKey(key);
                    if (value != "" && formattedKey != "") {
                        utmParams += `${formattedKey}=${value}&`;
                    }      
                  }
            }
        } catch (error) {
            console.error("Failed to retrieve utms from localStorage marketingContext with error:", error);
        }
    }
    
    if (utmParams.length > 0) {
        utmParams = utmParams.slice(0, -1); // remove trailing &
        var $link = this.$domRoot.children("a");
        var oldHref = $link.attr("href");
        if (oldHref?.indexOf("?") != -1) {
            $link.attr("href", oldHref + "&" + utmParams);
        } else {
            $link.attr("href", oldHref + "?" + utmParams);
        }
    }
  }
}
